module.exports = __webpack_public_path__ + "static/media/placas.b64ae08e.gif";